import { InjectionToken } from '@angular/core';

export interface IConfig {
  apiUrl: string;
}

export const API_CONFIG_TOKEN = new InjectionToken<IConfig>('config');
